import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist6/integration/react';

import * as serviceWorker from './serviceWorker';
import { store, persistor } from './store';
import ShellContainer from './modules/shell';
import './index.scss';

// Hide splash screen
setTimeout(() => {
  document.getElementById('splash').remove();
}, 1000);

setTimeout(() => {
  document.getElementById('splash').style.opacity = 0;
}, 500);

const viewport = window.visualViewport;

if (viewport) {
  const viewportHandler = () => {
    const zoom = document.documentElement.clientWidth / window.innerWidth;
    if (zoom <= 1) {
      // The trick to viewport units on mobile devices
      document.documentElement.style.setProperty('--vh', `${viewport.height}px`);
    }
  };

  viewportHandler();

  viewport.addEventListener('resize', viewportHandler);
} else {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ShellContainer />
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
